import { useMutation, useMutationState, useQuery, useQueryClient } from "@tanstack/react-query"
import axios from "axios"

export function useClientSubscriptionCreate() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ["create-subscription"],
    mutationFn: async (requestConfig) => {
      let requestData = requestConfig.body;
      if (typeof requestData === 'string') {
        requestData = JSON.parse(requestData);
      }
      return axios({
        url: [process.env.REACT_APP_API_URL, "/create-subscription"].join(""),
        method: requestConfig.method || "POST",
        withCredentials: true,
        data: requestData,
        headers: requestConfig.headers || { 'Content-Type': 'application/json' },
      })
        .catch((error) => {
      
          if (error?.response?.status === 401) {
            queryClient.invalidateQueries({
              queryKey: ["session-lookup"],
            })
          }

          throw error?.response?.data ?? error
        })
    },
  })
}
export function useClientSubscriptionCreateState() {
  const states = useMutationState({
    filters: {
      mutationKey: ["create-subscription"],
    },
    select: (mutation) =>
      Object.assign(mutation.state, {
        isIdle: mutation.state.status === "idle",
        isPending: mutation.state.status === "pending",
        isSuccess: mutation.state.status === "success",
        isError: mutation.state.status === "error",
        isDone: mutation.state.status === "success" || mutation.state.status === "error",
      }),
  })

  return states[states.length - 1] ?? {}
}

export function useClientSubscriptionLookup() {
  return useQuery({
    queryKey: ["client-subscription-lookup"],
    queryFn: async () => {
      console.log('=== FETCHING CLIENT SUBSCRIPTIONS ===');
      
      try {
        const response = await axios({
          url: [process.env.REACT_APP_API_URL, "/subscription-lookup"].join(""),
          method: "GET",
          withCredentials: true,
        });

        console.log('Raw API Response:', response);
        console.log('Response Data:', response.data);
        if (response.data && response.data.ok && response.data.data) {
          console.log('Processed Data:', response.data.data);
          return response.data.data;
        }
        console.warn('Unexpected response format:', response.data);
        return response.data || [];

      } catch (error) {
        console.error('Subscription lookup error:', error);
        console.error('Error response:', error.response);
        
        if (error?.response?.status === 401) {
          console.log('Authentication error detected');
        }

        throw error?.response?.data ?? error;
      }
    },
    staleTime: 5 * 60 * 1000, 
    cacheTime: 10 * 60 * 1000, 
    refetchOnWindowFocus: false,
    retry: 1,
  });
}